import { styled, Card } from "@mui/material";

export const ColoredCard = styled(Card)<{
  type:
    | "warning"
    | "error"
    | "success"
    | "primary"
    | "grey"
    | "greyMid"
    | "info";
}>(({ theme, type }) => ({
  "&::before": {
    opacity: type === "grey" || type === "greyMid" ? 1 : 0.1,
    content: "''",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: -1,
  },
  position: "relative",
  padding: theme.spacing(3),
  borderRadius: 8,
  zIndex: 0,
  variants: [
    {
      props: {
        type: "error",
      },
      style: {
        "&::before": {
          background: theme.palette.error.main,
        },
      },
    },
    {
      props: {
        type: "warning",
      },
      style: {
        "&::before": {
          background: theme.palette.warning.main,
        },
      },
    },
    {
      props: {
        type: "primary",
      },
      style: {
        "&::before": {
          background: theme.palette.primary.main,
        },
      },
    },
    {
      props: {
        type: "info",
      },
      style: {
        "&::before": {
          background: theme.palette.info.main,
        },
      },
    },
    {
      props: {
        type: "grey",
      },
      style: {
        "&::before": {
          background: theme.palette.grey[50],
        },
      },
    },
    {
      props: {
        type: "greyMid",
      },
      style: {
        "&::before": {
          background: theme.palette.grey[100],
        },
      },
    },
    {
      props: {
        type: "success",
      },
      style: {
        "&::before": {
          background: theme.palette.success.main,
        },
      },
    },
  ],
}));
